module.exports = __webpack_public_path__ + "img/sv19.0038f806.svg";